/* eslint-disable no-console */
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { ProductOptionPicker } from '../Product/ProductOptionPicker';

@Component
export class ProductAccordion extends ThemeComponent {
    @Prop product!: Shopify.Liquid.Product;
    @Prop defaultVariant!: Shopify.Liquid.Variant;

    @Ref accordions!: HTMLElement[];

    // eslint-disable-next-line @typescript-eslint/naming-convention
    protected _selectedVariant: Shopify.Liquid.Variant | null = null;
    protected get selectedVariant() {
        return this._selectedVariant;
    }
    protected set selectedVariant(v) {
        this._selectedVariant = v;
        // this.handleVariantChanged();
    }

    private productOptionPicker = document.querySelector('.product-option-picker') as ProductOptionPicker || null;

    init() {
        // Set default variant
        this.selectedVariant = this.defaultVariant;

        this.updateAccordion(this.defaultVariant.id);

        this.$subscribe(this.productOptionPicker.onSelectedVariantChange, (variant) => {

            // Set selected variant value
            if (variant === null) {
                return;
            }
            this.selectedVariant = variant;
            this.updateAccordion(variant.id);
        });

    }

    private updateAccordion(variantId: number) {
        for (const accordion of this.accordions) {
            const accordionId = accordion.dataset.variant;
            const numVariantId = variantId.toString();

            if (accordionId == numVariantId) {
                accordion.classList.remove('hidden');
            } else {
                accordion.classList.add('hidden');
            }
        }

    }
}
